import { Box, Paragraph } from 'grommet'
import styled, { css } from 'styled-components'

export const Wrapper = styled(Box)`
  width: 125px;

  ${({ theme }) => css`
    margin-bottom: ${theme.newSpaces.md}px;
    margin-right: ${theme.newSpaces.lg}px;

    ${theme.below.mobileXL`
      width: 100%;
      height:100%;
      justify-content: space-between;
      margin:0;
    `}
  `};
`

export const Amount = styled(Paragraph)`
  ${({ theme }) => css`
    ${theme.getTypography('mobile', 'body', 'body3')};

    color: ${theme.newColors.accent};
  `}
`

export const Role = styled(Amount)`
  ${({ theme }) => css`
    ${theme.getTypography('mobile', 'preText', 'text1')};

    border-bottom: 2px solid ${theme.newColors.coldGray};
    color: ${theme.newColors.darkGray};

    ${theme.below.mobileXL`
      ${theme.getTypography('mobile', 'body', 'body4')};
    `}
  `}
`
